module.exports = __webpack_public_path__ + "static/media/tl.214b6f84.svg";